<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right">
        <button
          v-if="role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)"
          class="btn add-btn"
          @click="$router.push({ name: 'insuranceDependentDependentAdd' })"
        >
          <i class="fa fa-plus"></i>New Dependent
        </button>
      </div>
    </div>
    <!-- Begin: Popover for Filter -->
    <div>
      <popover
        name="popEmployee"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranEmployee"
          :options="colFilter.tranEmployeeColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popYear"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranYear"
          :options="colFilter.tranYearColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popName"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranName"
          :options="colFilter.tranNameColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popDental"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranDental"
          :options="colFilter.tranDentalColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popHsmm"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranHsmm"
          :options="colFilter.tranHsmmColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popRelationship"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranRelationship"
          :options="colFilter.tranRelationshipColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popIc"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranIc"
          :options="colFilter.tranIcColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popNationality"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranNationality"
          :options="colFilter.tranNationalityColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popGender"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranGender"
          :options="colFilter.tranGenderColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popBirthday"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranBirthday"
          :options="colFilter.tranBirthdayColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popAge"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranAge"
          :options="colFilter.tranAgeColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popFullTime"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranFullTime"
          :options="colFilter.tranFullTimeColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
    </div>
    <!--End: Popover for Filter-->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th v-if="role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)" class="text-center action-column">Action</th>
                <th v-if="role == 'admin'">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmployee
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmployee.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('employee')">
                    Employee Name (Emp ID)
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'employee'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'employee_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popYear
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranYear.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('year')">
                    Insurance Year
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'year'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'year_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popDental
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranDental.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('dental')">
                    Group Dental
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'dental'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'dental_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popHsmm
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranHsmm.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('hsmm')">
                    Group H&S and MM
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'hsmm'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'hsmm_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  
                  <button class="btn p-0" @click="setSortBy('maritalStatus')">
                    Dependent Marital Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'maritalStatus'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'maritalStatus_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popRelationship
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranRelationship.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('relationship')">
                    Dependent Relationship
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'relationship'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'relationship_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popIc
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranIc.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('ic')">
                    Dependent IC Number
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'ic'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'ic_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popNationality
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranNationality.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('nationality')">
                    Dependent Nationality
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'nationality'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'nationality_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popGender
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranGender.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('gender')">
                    Dependent Gender
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'gender'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'gender_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popBirthday
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranBirthday.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('birthday')">
                    Dependent Birthday
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'birthday'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'birthday_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popAge
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranAge.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('age')">
                    Dependent Age
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'age'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'age_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popFullTime
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranFullTime.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('fullTime')">
                    Is your child on full-time studies?
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'fullTime'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'fullTime_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dependents" :key="item.Id">
                <td v-if="role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)">
                  <router-link  v-if="role == 'admin' || (role == 'employee' && item.IsChangeAllowForEmployee) || (role == 'employee' && isNewEmployee)"
                    class="btn"
                    title="Edit"
                    :to="{
                      name: 'insuranceDependentDependentEdit',
                      params: { id: item.Id },
                    }"
                  >
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <button  v-if="role == 'admin' || (role == 'employee' && item.IsChangeAllowForEmployee) || (role == 'employee' && isNewEmployee)"
                    class="btn"
                    title="Delete"
                    @click="remove(item.Id)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
                <td v-if="role == 'admin'">{{ item.Employee }}</td>
                <td>{{ item.YearDisplay }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.GroupDentalDisplay }}</td>
                <td>{{ item.GroupHsmmDisplay }}</td>
                <td>{{ item.MaritalStatus }}</td>
                <td>{{ item.Relationship }}</td>
                <td>{{ item.Ic }}</td>
                <td>{{ item.Nationality }}</td>
                <td>{{ item.GenderDisplay }}</td>
                <td>{{ item.BirthdayDisplay }}</td>
                <td>{{ item.AgeDisplay }}</td>
                <td>{{ item.FullTimeDisplay }}</td>
              </tr>
              <tr v-if="dependents && !dependents.length">
                <td
                  :colspan="role == 'admin' ? '14' : (role == 'employee' && (isEnrolmentOpen || isNewEmployee) ? '13' : '12')"
                  class="text-center"
                >
                  {{ this.noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="dependents && dependents.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          dependents.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import Multiselect from "vue-multiselect";
import config from "../../../config.js";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      dependents: null,
      isEnrolmentOpen: false,
      isNewEmployee: false,
      noRecordText: config.NO_RECORD_TEXT,
      //for pagination
      searchColFilter: {
        tranEmployee: [],
        tranYear: [],
        tranName: [],
        tranDental: [],
        tranHsmm: [],
        tranRelationship: [],
        tranIc: [],
        tranNationality: [],
        tranGender: [],
        tranBirthday: [],
        tranAge: [],
        tranFullTime: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    searchFilter() {
      return [
        { name: "tranEmployee", val: this.searchColFilter.tranEmployee },
        { name: "tranYear", val: this.searchColFilter.tranYear },
        { name: "tranName", val: this.searchColFilter.tranName },
        { name: "tranDental", val: this.searchColFilter.tranDental },
        { name: "tranHsmm", val: this.searchColFilter.tranHsmm },
        {
          name: "tranRelationship",
          val: this.searchColFilter.tranRelationship,
        },
        { name: "tranIc", val: this.searchColFilter.tranIc },
        { name: "tranNationality", val: this.searchColFilter.tranNationality },
        { name: "tranGender", val: this.searchColFilter.tranGender },
        { name: "tranBirthday", val: this.searchColFilter.tranBirthday },
        { name: "tranAge", val: this.searchColFilter.tranAge },
        { name: "tranFullTime", val: this.searchColFilter.tranFullTime },
      ];
    },
  },

  watch: {
    "searchColFilter.tranEmployee": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranYear": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranName": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranDental": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranHsmm": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranRelationship": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranIc": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranNationality": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranGender": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranBirthday": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranAge": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "searchColFilter.tranFullTime": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "paging.Search": function (val, oldVal) {
      this.getEmployeeDependents();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getEmployeeDependents();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteEmployeeDependent(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getEmployeeDependents();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEmployeeDependents() {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeDependent(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.dependents = response.data.record;
            this.isEnrolmentOpen = response.data.isEnrolmentOpen;
            this.isNewEmployee = response.data.isNewEmployee;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEmployeeDependents();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEmployeeDependents();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEmployeeDependents();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEmployeeDependents();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEmployeeDependents();
    },
    setSortBy(payload) {
      switch (payload) {
        case "employee":
          if (this.paging.SortBy === "employee") {
            this.paging.SortBy = "employee_desc";
          } else if (this.paging.SortBy === "employee_desc") {
            this.paging.SortBy = "employee";
          } else {
            this.paging.SortBy = "employee";
          }
          break;
        case "year":
          if (this.paging.SortBy === "year") {
            this.paging.SortBy = "year_desc";
          } else if (this.paging.SortBy === "year_desc") {
            this.paging.SortBy = "year";
          } else {
            this.paging.SortBy = "year";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "dental":
          if (this.paging.SortBy === "dental") {
            this.paging.SortBy = "dental_desc";
          } else if (this.paging.SortBy === "dental_desc") {
            this.paging.SortBy = "dental";
          } else {
            this.paging.SortBy = "dental";
          }
          break;
        case "hsmm":
          if (this.paging.SortBy === "hsmm") {
            this.paging.SortBy = "hsmm_desc";
          } else if (this.paging.SortBy === "hsmm_desc") {
            this.paging.SortBy = "hsmm";
          } else {
            this.paging.SortBy = "hsmm";
          }
          break;
        case "relationship":
          if (this.paging.SortBy === "relationship") {
            this.paging.SortBy = "relationship_desc";
          } else if (this.paging.SortBy === "relationship_desc") {
            this.paging.SortBy = "relationship";
          } else {
            this.paging.SortBy = "relationship";
          }
          break;
        case "ic":
          if (this.paging.SortBy === "ic") {
            this.paging.SortBy = "ic_desc";
          } else if (this.paging.SortBy === "ic_desc") {
            this.paging.SortBy = "ic";
          } else {
            this.paging.SortBy = "ic";
          }
          break;
        case "nationality":
          if (this.paging.SortBy === "nationality") {
            this.paging.SortBy = "nationality_desc";
          } else if (this.paging.SortBy === "nationality_desc") {
            this.paging.SortBy = "nationality";
          } else {
            this.paging.SortBy = "nationality";
          }
          break;
        case "gender":
          if (this.paging.SortBy === "gender") {
            this.paging.SortBy = "gender_desc";
          } else if (this.paging.SortBy === "gender_desc") {
            this.paging.SortBy = "gender";
          } else {
            this.paging.SortBy = "gender";
          }
          break;
        case "birthday":
          if (this.paging.SortBy === "birthday") {
            this.paging.SortBy = "birthday_desc";
          } else if (this.paging.SortBy === "birthday_desc") {
            this.paging.SortBy = "birthday";
          } else {
            this.paging.SortBy = "birthday";
          }
          break;
        case "age":
          if (this.paging.SortBy === "age") {
            this.paging.SortBy = "age_desc";
          } else if (this.paging.SortBy === "age_desc") {
            this.paging.SortBy = "age";
          } else {
            this.paging.SortBy = "age";
          }
          break;
        case "fullTime":
          if (this.paging.SortBy === "fullTime") {
            this.paging.SortBy = "fullTime_desc";
          } else if (this.paging.SortBy === "fullTime_desc") {
            this.paging.SortBy = "fullTime";
          } else {
            this.paging.SortBy = "fullTime";
          }
          break;
      }
      this.getEmployeeDependents();
    },
  },

  created() {
    this.getEmployeeDependents();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/DependentList.vue